import { inject, InjectionToken } from "@angular/core";
import { Route } from "@angular/router";
import { DynamicTabsService } from "@app/shared-core/general/dynamic-tabs/dynamic-tabs.service";
import { NotificationSettingsRoutePaths } from "@app/applications/settings/domains/notification-settings/notification-settings-route-path";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";
import { QuotationNotificationSettingsRoutePaths } from "../quotation-notification-settings-paths";
import { quotationNotificationSettingsRoutes } from "../quotation-notification-settings.routes";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const quotationNotificationSettingsDynamicRoutesConfig: Route[] = [
  {
    path: NotificationSettingsRoutePaths.ROOT,
    children: [
      {
        path: "",
        children: quotationNotificationSettingsRoutes,
      },
    ],
  },
];

export const ADD_QUOTATION_NOTIFICATION_SETTINGS_TABS = new InjectionToken("ADD_QUOTATION_NOTIFICATION_SETTINGS_ROUTES", {
  providedIn: "root",
  factory: () => {
    inject(DynamicTabsService).addTabs(
      NotificationSettingsRoutePaths.ROOT,
      [
        {
          route: QuotationNotificationSettingsRoutePaths.ROOT,
          label: "QUOTATION_NOTIFICATION_SETTINGS.TITLES.QUOTATION_NOTIFICATION_SETTINGS",
          permissions: [PERMISSION_CONSTANTS.QUOTATION_NOTIFICATION_SETTINGS.VIEW, PERMISSION_CONSTANTS.QUOTATION_NOTIFICATION_SETTINGS.SET],
        },
      ],
      { parentRoutePath: APP_ROUTE_PATHS.SETTINGS, routes: quotationNotificationSettingsDynamicRoutesConfig }
    );
  },
});
